const BASE_HOST = process.env.VUE_APP_SERVER_URL || '';

export const config = {
  SERVER_URL: BASE_HOST,
  API_URL: `${BASE_HOST}/api`,
  TOR_API_URL: `${BASE_HOST}/tor`,
  COMM_API_URL: `${BASE_HOST}/communication-api`,
  APP_API_URL: `${BASE_HOST}/app-api`,
  PUBLIC_URL: `${BASE_HOST}/app-public`,
  GRAPH_API_URL: `${BASE_HOST}/graph-api`,
  CRM_API_URL: `${BASE_HOST}/crm-api`,
  PORTAL_API_URL: `${BASE_HOST}/portal-api`,
  PDFGENERATOR_API_URL: `${BASE_HOST}/pdfgenerator`,
  EXPORT_API_URL: `${BASE_HOST}/export`,
  PERMISSIONS_API_URL: `${BASE_HOST}/permissions`,
  QUESTIONAIRE_API_URL: `${BASE_HOST}/umfrage`,
  CARBONE_API_URL: `${BASE_HOST}/carbone-api`,
  AUSWAHLWERTE_API_URL: `${BASE_HOST}/selection-values`,
  KOTLIN_API_URL: `${BASE_HOST}/kotlin-api`,
};
